package com.macrofocus.common.json

actual object JSON {
    actual fun <T : JsonValue?> parse(text: String): T {
        return kotlin.js.JSON.parse<T>(text)
    }
}